export default {
  TableHead: [
    [
      {
        displayName: 'memberoutstanding.datatable.number',
      },
      {
        displayName: 'memberoutstanding.datatable.username',
      },
      {
        displayName: 'memberoutstanding.datatable.position',
      },
      {
        displayName: 'memberoutstanding.datatable.stake',
      },
      {
        displayName: 'memberoutstanding.datatable.turnover',
      },
      {
        displayName: 'memberoutstanding.datatable.companytotal',
      },
    ],
  ],
};
